import * as React from 'react';
import { Layout } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import { getTime } from '../../../helpers/time.js';
import modules_1e75be7a from '../styles/Bottom.module.less.js';
import Copyrights from './Copyrights.js';
import Navigation from './Navigation.js';
import Support from './Support.js';

/**
 * @description Bottom block of footer.
 *
 * @component
 * @example
 * ```jsx
 * <Bottom />
 * ```
 */
const Bottom = React.forwardRef((props, ref) => {
    const { menuLinks, className, mode, support, ...restProps } = props;
    const { supportStart, supportEnd } = support;
    const cx = useStyles(modules_1e75be7a);
    const [showNavigation, showCopyrights, showSupport] = React.useMemo(() => {
        switch (mode) {
            case 'landing': {
                return [false, true, false];
            }
            case 'encyclopedia': {
                return [true, true, false];
            }
            default: {
                return [true, true, true];
            }
        }
    }, [mode]);
    const isShowSupportBlock = React.useMemo(() => {
        const moscowTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
        const currentTime = moscowTime.getHours() * 60 + moscowTime.getMinutes();
        return showSupport && currentTime >= getTime(supportStart) && currentTime < getTime(supportEnd);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showSupport]);
    return (React.createElement(Layout, { ref: ref, className: cx(className, 'container', 'bottom-block'), ...restProps },
        React.createElement("div", { className: cx('bottom-block__wrapper') },
            (showNavigation || showCopyrights) && (
            // eslint-disable-next-line @typescript-eslint/naming-convention
            React.createElement("div", { className: cx({ 'bottom-block__left': isShowSupportBlock }) },
                showNavigation && React.createElement(Navigation, { menuLinks: menuLinks }),
                showCopyrights && React.createElement(Copyrights, { hasNoIndex: isShowSupportBlock }))),
            showSupport && isShowSupportBlock ? (React.createElement("div", { className: cx('bottom-block__right') },
                React.createElement(Support, { ...support }))) : null)));
});
Bottom.defaultProps = {};

export { Bottom as default };
//# sourceMappingURL=Bottom.js.map
